import {MenuItem} from '@material-ui/core';
import {changeMessagesFilter, searchMessages, resendMessage} from 'GenericTexting/ducks/message';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {
  withStringFilterProperties,
  withDateFilterProperties,
  withRegExStringFilterProperties,
} from 'Shared/components/PagedView/Filter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import './Messages.sass';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import {toFormattedDateAsEstWithSeconds} from 'Shared/utilities/DateFormatter';
import {hasScope} from 'Shared/components/RequireScope';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import {Scope} from 'Shared/constants/Scope';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import PagedView from 'Shared/components/PagedView/PagedView';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';

const Messages = () => {
  const dispatch = useDispatch();
  const scopes = useSelector(selectUserScopes);
  const userHasScope = hasScope(scopes);
  const {filter, messages} = useSelector((state: ReducerState) => state.messages);

  const changeFilter = withValueChangedHook(filter, changeMessagesFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
    dispatch(searchMessages(undefined, filter));
  }, [dispatch, filter]);

  return (
    <ModularHost>
      <ToolbarHeader title="Messages" />
      <PagedView pagedViewKey="messages" loadMore={page => dispatch(searchMessages(page, filter))} data={messages}>
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Phone Number"
              filterProperties={withStringFilterProperties(filterProperties, 'phoneNumber')}
              default
            >
              {message => message.phoneNumber}
            </Column>
            <Column
              {...columnProps}
              title="Short Code"
              filterProperties={withStringFilterProperties(filterProperties, 'shortCode')}
              default
            >
              {message => message.shortCode}
            </Column>
            <Column
              {...columnProps}
              title="Message Id"
              filterProperties={withStringFilterProperties(filterProperties, 'messageId')}
              default
            >
              {message => message.messageId}
            </Column>
            <Column
              {...columnProps}
              title="Message"
              filterProperties={withStringFilterProperties(filterProperties, 'message')}
              default
            >
              {message => message.message}
            </Column>
            <Column
              {...columnProps}
              title="Subscription List"
              filterProperties={withRegExStringFilterProperties(filterProperties, 'subscriptionList', /\d/g)}
              default
            >
              {message => message.subscriptionList}
            </Column>
            <Column
              {...columnProps}
              title="Client"
              filterProperties={withStringFilterProperties(filterProperties, 'clientName')}
              default
            >
              {message => message.client!.clientName}
            </Column>
            <Column
              {...columnProps}
              title="Keywords"
              filterProperties={withStringFilterProperties(filterProperties, 'keywords')}
              default
            >
              {message => message.keywords!.join(', ')}
            </Column>
            <Column
              {...columnProps}
              title="Time Stamp (EST)"
              filterProperties={withDateFilterProperties(filterProperties, 'timeStamp')}
              default
            >
              {message => toFormattedDateAsEstWithSeconds(message.timeStamp!.toString())}
            </Column>
            {userHasScope(Scope.SendMessages) && (
              <Column title="Actions" {...columnProps} isActions default>
                {message => (
                  <>
                    <ActionsMenu>
                      <MenuItem
                        disabled={message.message === 'UNSUBSCRIBED'}
                        onClick={() => dispatch(resendMessage(message))}
                      >
                        Resend
                      </MenuItem>
                    </ActionsMenu>
                  </>
                )}
              </Column>
            )}
          </>
        )}
      </PagedView>
    </ModularHost>
  );
};

export default Messages;
